import {HashRouter} from "react-router-dom"; //BrowserRouter
import CamelusRoutes from "./routing/routes";
import AuthProvider from "./components/auth/request/AuthProvider";
import SearchProvider from "./components/search/SearchProvider";
import ContratosProvider from "./components/contratos/ContratosProvider";
import { ToastProvider } from "./components/notificaciones/ToastProvider";

export default function App() {
    return (
        <HashRouter>
            {/* Login data */}
            <AuthProvider>
                {/* Search data */}
                <SearchProvider>
                    {/* Activar notificación*/}
                    <ToastProvider>
                        {/* Datos de contratos */}
                        <ContratosProvider>
                            {/* Router */}
                            <CamelusRoutes></CamelusRoutes>
                        </ContratosProvider>
                    </ToastProvider>
                </SearchProvider>
            </AuthProvider>
        </HashRouter>
    );
}

//////////// servidor /////////
/*
 <HashRouter>
    {/* Login data
    <AuthProvider>
    {/* Search data
    <SearchProvider>
        {/*Router
        <CamelusRoutes></CamelusRoutes>
    </SearchProvider>
  </AuthProvider>
</HashRouter>
*/


/////////////////////
/*
<BrowserRouter basename="/web-noemi">
        {/* Login data
        <AuthProvider>
        {/* Search data
        <SearchProvider>
            {/*Router
            <CamelusRoutes></CamelusRoutes>
        </SearchProvider>
      </AuthProvider>
    </BrowserRouter>
*/
